// removed by extract-text-webpack-plugin
module.exports = {"versionWrap":"TLvU4wASyjCcEPtBmVIAz"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/VersionTemplate/VersionTemplate.styl
// module id = 750
// module chunks = 0